import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { NewrelicService } from '../../services/newrelic/newrelic.service';
import { StaticValuesUtils } from '../../utils/static-values/static-values.utils';
import { TransfersBanners } from '../../shared/models/domain/transfers-banners';
import { BannerService } from '../../services/banner/banner.service';
import { EmptyState } from '../../shared/models/domain/empty-state';
import { TranslateService } from '@ngx-translate/core';
import { AppSettingsService } from '../../services/app-settings/app-settings.service';
import { LoyaltyMode, LoyaltyService } from '@shopping-angular-components/loyalty';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { ScreenUtils } from 'src/app/utils/screen.utils';
import { CityInfo } from 'src/app/shared/models/domain/cityInfo';
import { ClusterBanner } from '../../shared/models/domain/cluster-banner';
import { WindowService } from '../../services/window/window.service';
import { TimmingsService } from '../../services/timmings/timmings.service';
import { SearchResponse } from 'src/app/shared/models/domain/search-response';
import { Travel } from 'src/app/shared/models/domain/travel';
import { Utils } from 'src/app/utils/utils';
import { CookieService } from '@shopping-angular-components/common-library';
import { CROSS_SELLING_COUPON_COOKIE_NAME, X_PREFERRED_CURRENCY_CODE_COOKIE } from 'src/app/utils/constants/constants';
import { Item } from 'src/app/shared/models/domain/item';
import { DatalayerService } from 'src/app/services/datalayer.service';
import { Message, MessageType } from 'src/app/shared/models/message-types.enum';
import { URLParamsConstants } from 'src/app/utils/constants/UrlConstants';
import { EventType } from 'src/app/models/evenType.enum';
import { CurrencyService } from 'src/app/services/currency/currency.service';
import { CurrencyConstants } from '../../models/constants/currency.constants';
import { ModalData, ModalService } from '@shopping-angular-components/modal';
import { DualCurrencyModalWrapperComponent } from '../modal/dual-currency-modal-wrapper/dual-currency-modal-wrapper.component';
import { DualCurrencyModalService } from '@shopping-angular-components/dual-currency-modal';

@Component({
  selector: 'results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss'],
})
export class ResultsComponent implements OnInit, OnDestroy {
  private queryParamsSubscription: Subscription;
  private activatedRouteSubscription: Subscription;

  private readonly redemptionSwitchOptions: any;

  searchResponse: SearchResponse;
  tabFilterSelection: string;
  highHeavy: boolean;
  responseLoaded: boolean = false;
  sboxData: Travel;
  showSbox: boolean = false;
  banners: TransfersBanners;
  emptyState: EmptyState;
  isMobile: boolean = ScreenUtils.isMobile();
  destinationCity: CityInfo;
  cityGid: string;

  isFavoriteHighlighted: boolean = false;
  loyaltyMode: LoyaltyMode = LoyaltyMode.COUNTRY_OFF;
  isLoyaltyEnabled: boolean = false;
  private loyaltyModeSubscription: Subscription | null = null;
  isAgencyModeAvailable: boolean = null;

  private eventListener: (event: CustomEvent) => void;
  private reload$ = new BehaviorSubject<void>(null);

  message: Message = { text: '', type: MessageType.Info };

  showCurrencySelector: boolean = false;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly apiService: ApiService,
    private readonly bannerService: BannerService,
    private readonly translateService: TranslateService,
    private readonly newRelicService: NewrelicService,
    private readonly appSettingsService: AppSettingsService,
    private readonly loyaltyService: LoyaltyService,
    private readonly windowService: WindowService,
    private readonly timmingsService: TimmingsService,
    private readonly cookieService: CookieService,
    private readonly title: Title,
    private readonly meta: Meta,
    private readonly datalayerService: DatalayerService,
    private readonly currencyService: CurrencyService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly modalService: ModalService,
    private readonly dcmService: DualCurrencyModalService,
  ) {
    this.redemptionSwitchOptions = {
      pr: this.appSettingsService.getProduct(),
      fl: this.appSettingsService.getFlow(),
      flow_type: this.appSettingsService.getFlowType(),
      pageview_id: this.appSettingsService.getPageViewId()
    };
  }

  ngOnInit(): void {

    this.reload$.subscribe(() => {
      this.activatedRoute.paramMap.subscribe({
        next: (params) => {
          this.loadResults(params);
        },
        error: (err) => {
          console.error('Error en ActivatedRoute.paramMap:', err);
        },
        complete: () => {
          //
        }
      });
    });

    this.eventListener = (event: CustomEvent) => {
      if (event.type === EventType.ShifuCurrencyChange) {
        this.reloadData();
      }
    };

    this.eventListener = (event: CustomEvent) => {
      if (event.type === EventType.ChangeCurrencyEvent) {
          this.reloadData();
          this.cdr.detectChanges();
      }
    };

    this.registerEventListeners();

  }

  private registerEventListeners() {
    window.addEventListener(EventType.ChanchitoCuponEvent, this.handleChanchitoEvent.bind(this));
    document.addEventListener(EventType.ShifuCurrencyChange, this.eventListener);
    document.addEventListener(EventType.ChangeCurrencyEvent, this.eventListener);
  }

  private loadResults(params: ParamMap): void {
    const skeleton = document.getElementById('skeleton');

    this.activatedRouteSubscription = this.activatedRoute.paramMap.subscribe((params) => {

      const preferredCurrency = this.cookieService.get(X_PREFERRED_CURRENCY_CODE_COOKIE);
      const selectedCurrency = preferredCurrency ?  preferredCurrency : this.currencyService.getSelectedCurrency()?.value ?? null;
      const isPartnerMode = StaticValuesUtils.isPartnerAvailableCurrenciesEnabled() && preferredCurrency;
      const currencyKey = isPartnerMode ? 'currencies' : 'currency';
      const currencyValue = isPartnerMode ? preferredCurrency : selectedCurrency;

      const newParams = {
          params: {
            ...this.activatedRoute.snapshot.params,
            [currencyKey]: currencyValue
          }
      };

      this.apiService.getSearchResponse(newParams).subscribe({
        next: (response: SearchResponse) => {
          this.searchResponse = response;

         if (!this.selectedCurrencyDefined()) {
            this.currencyService.updateCurrenciesValue(this.searchResponse);
         }

          this.comparePrices(response);
          this.highlightClosestItem(response);
          this.trackResultEvents(response, newParams);
          this.datalayerService.setDatalayer(response);
          skeleton.style.display = 'none';
          this.highHeavy = this.isHighHeavy();
          this.responseLoaded = true;
          this.banners = response.banners ? this.bannerService.initializeBanners(response.banners) : null;
          this.emptyState = response.emptyStates ? response.emptyStates[0] : null;
          this.sboxData = this.searchResponse.travel;
          this.showSbox = true;

          this.title.setTitle(this.resolveTitle());
          this.meta.updateTag({ name: "description", content: this.translateMsg('results.message.description') });

          if (this.searchResponse?.travel?.points && this.searchResponse.travel.points[0]?.destination) {
            this.cityGid = this.searchResponse.travel.points[0].destination.city.gid;
            this.destinationCity = {
              text: this.searchResponse.travel.points[0].destination.city.name,
              code: this.searchResponse.travel.points[0].destination.city.iata
            };
          } else if (this.searchResponse?.items && this.searchResponse.items[0]?.outwardSegment) {
            this.destinationCity = {
              text: this.searchResponse.items[0].outwardSegment.destination.name,
              code: this.searchResponse.items[0].outwardSegment.destination.code
            };
          }

          this.isLoyaltyEnabled = this.showRedemptionSwitch();

          if (this.isLoyaltyEnabled) {
            // Inicializamos loyalty-redemption-switch
            this.loyaltyService.initLoyaltyRedemptionSwitch(
              this.appSettingsService.getLocale(),
              this.redemptionSwitchOptions,
              !this.appSettingsService.isWebview(), // En Shopping UI, el parámetro collapsedDesign debe ser true si NO estamos en webview
              'redemption-switch-placeholder'
            );

            // Nos suscribimos al cambio de modo
            this.loyaltyModeSubscription = this.loyaltyService.mode$.subscribe({
              next: (loyaltyMode: LoyaltyMode) => {
                if (this.loyaltyMode !== loyaltyMode) {
                  // Actualizamos la variable de instancia loyaltyMode que vamos a pasar a otros componentes
                  this.loyaltyMode = loyaltyMode;
                }
              }
            });
          }


          this.showCurrencySelector = !StaticValuesUtils.isPartnerAvailableCurrenciesEnabled() && this.searchResponse.bimonetaryContext;

          if (this.searchResponse?.items) {
            this.initAgencyModeButton();

            const currentCurrency = currencyValue ?? this.currencyService.getSelectedCurrency()?.value;
            if (this.searchResponse.items.length > 0 && this.searchResponse.bimonetaryContext && currentCurrency === CurrencyConstants.CURRENCY_CODE_USD) {
              this.openBimonetaryNotificationModal();
            }

          }

          this.shifuInitMetrics(response, newParams);

          this.timmingsService.trackMainFeature(this.timmingsService.getDefaultTrackingData(), this.appSettingsService.getUow(), this.appSettingsService.getPageViewId());

        },
        error: () => {
          this.newRelicService.trackToInsights('resultsError', {});
          skeleton.style.display = 'none';
          this.emptyState = this.getErrorEmptyState();
          this.showSbox = true;
        }
      });
    });
  }

  handleChanchitoEvent(event: Event): void {
    const eventDetail = (event as CustomEvent).detail;

    switch (eventDetail.type) {
        case "userActivatedCoupon":
            this.handleUserActivatedCoupon();
            break;

        case "filtered":
            this.applyFilters();
            break;

        case "unfiltered":
            this.clearFilters();
            break;
    }
  }

  private handleUserActivatedCoupon(): void {
      if (this.cookieService.get(CROSS_SELLING_COUPON_COOKIE_NAME) === 'true') {
          const scrollPosition = window.scrollY;
          localStorage.setItem('scrollPosition', scrollPosition.toString());
          window.location.reload();
      }
  }

  private applyFilters(): void {
      this.addPromotionsToUrl();
      StaticValuesUtils.setCouponFilter(true);
      StaticValuesUtils.setPromotions("ALL");
      this.reloadData();
      this.cdr.detectChanges();
  }

  private clearFilters(): void {
      this.removePromotionsFromUrl();
      StaticValuesUtils.setCouponFilter(false);
      StaticValuesUtils.setPromotions(null);
      this.reloadData();
      this.cdr.detectChanges();
  }

  private addPromotionsToUrl() {
    this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { promotions: "ALL" },
        replaceUrl: true,
        queryParamsHandling: 'merge',
    });
  }

  private removePromotionsFromUrl() {
    this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { promotions: null },
        replaceUrl: true,
        queryParamsHandling: 'merge',
    });
  }


  private getClosestIndex(items: Item[], startIndex: number): number {
    const checkCondition = (item: Item) => item?.promotion?.type;
    if (checkCondition(items[startIndex])) return startIndex;
    const indexBefore = [...items]
      .slice(0, startIndex)
      .reverse()
      .findIndex((item) => checkCondition(item));
    const indexAfter = items.slice(startIndex + 1).findIndex((item) => checkCondition(item));

    const closestIndexBefore = indexBefore >= 0 ? startIndex - 1 - indexBefore : -1;
    const closestIndexAfter = indexAfter >= 0 ? startIndex + 1 + indexAfter : -1;

    if (closestIndexBefore !== -1 && closestIndexAfter !== -1) {
      return startIndex - closestIndexBefore <= closestIndexAfter - startIndex ? closestIndexBefore : closestIndexAfter;
    } else if (closestIndexBefore !== -1) {
      return closestIndexBefore;
    } else {
      return closestIndexAfter;
    }
  }

  ngOnDestroy(): void {
    if (this.loyaltyModeSubscription) {
      this.loyaltyModeSubscription.unsubscribe();
      this.loyaltyModeSubscription = null;
    }

    window.removeEventListener(EventType.ChanchitoCuponEvent, this.handleChanchitoEvent.bind(this));
    document.removeEventListener(EventType.ShifuCurrencyChange, this.eventListener);
    document.removeEventListener(EventType.ChangeCurrencyEvent, this.eventListener);

    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }

    if (this.activatedRouteSubscription) {
      this.activatedRouteSubscription.unsubscribe();
    }

  }

  private highlightClosestItem(searchResponse: SearchResponse): void {
    const isXSCouponActive = this.cookieService.get(CROSS_SELLING_COUPON_COOKIE_NAME) === 'true';
    if (!isXSCouponActive) return;
    const closestIndex = this.getClosestIndex(searchResponse.items, 1);
    if (closestIndex !== -1) {
      searchResponse.items[closestIndex].hasCoachmark = true;
    }
  }

  private reloadData(): void {
    const skeleton = document.getElementById('skeleton');
    skeleton.style.display = 'block';
    this.searchResponse.items = null;
    document.body.scrollIntoView({ behavior: 'smooth' });
    this.reload$.next();
  }

  private showRedemptionSwitch(): boolean {
    return (this.responseLoaded && this.appSettingsService.isLoyaltyEnabled()) || this.appSettingsService.isWebview() || StaticValuesUtils.isPartner();
  }

  changeTabFilter(transferType): void {
    this.tabFilterSelection = transferType;
  }

  validateHighHeavyHighlight(transfer) {
    return this.highHeavy && transfer.transferServiceType === "PRIVATE";
  }

  private isHighHeavy(): boolean {
    return StaticValuesUtils.isHighAndHeavy();
  }

  /* Eventos generales en base a los resultados **/
  private trackResultEvents(response: SearchResponse, params: any): void {
    // @todo Trackear eventos relevantes.

    this.trackWebViewApp(response, params);
  }

  private trackWebViewApp(response: SearchResponse, paramMap: any) {
    if (StaticValuesUtils.isWebview()) {
      this.pushCustomDimensions(response, paramMap);
      const event = new Event('view_search_results');
      this.windowService.nativeWindow.dispatchEvent(event);
    }
  }

  private pushCustomDimensions(response: SearchResponse, paramMap: any) {
    var params = {
      Origin_City: response?.travel?.points[0]?.id,
      Destination_City: response?.travel?.points[1]?.id
    };
    if (paramMap?.params?.fromDate) {
      params['CheckIn_Date'] = paramMap?.params?.fromDate;
    }
    if (paramMap?.params?.toDate) {
      params['CheckIn_Date'] = paramMap?.params?.toDate;
    }
    window['dataLayer'].push(params);
  }

  private resolveTitle(): string {
    const travel = this.searchResponse.travel;

    if (!travel && !this.searchResponse.items) {
      return '';
    }

    let originName = '';
    if (travel?.points && travel.points[0]?.description) {
      originName = travel.points[0].description;
    } else if (this.searchResponse?.items && this.searchResponse?.items[0]?.outwardSegment) {
      originName = this.searchResponse.items[0].outwardSegment.origin.name;
    }

    let destinationName = '';
    if (travel?.points && travel?.points[1]?.description) {
      destinationName = travel.points[1].description;
    } else if (this.searchResponse?.items && this.searchResponse?.items[0]?.outwardSegment) {
      destinationName = this.searchResponse.items[0].outwardSegment.destination.name;
    }

    return originName != '' && destinationName != ''
      ? this.translateMsg('results.message.title', { origin: originName, destiny: destinationName })
      : '';
  }

  private getErrorEmptyState(): EmptyState {
    return {
      type: 'noResults',
      image: '4049b378-566a-459b-ada8-289dcfffb0be',
      title: this.translateMsg('results.message.noresults'),
      description: this.translateMsg('results.message.tryagain'),
      action: null,
      redirectTo: null,
    };
  }
  private translateMsg(key: string, params?: Object): string {
    return this.translateService.instant(key, params);
  }

  getNextBanner(order: number): ClusterBanner {
    return this.banners ? this.banners.clusterBanners.find(clusterBanner => clusterBanner.order === order) : null;
  }

  private initAgencyModeButton() {
    if (this.isAgencyModeAvailable === null && this.searchResponse?.items) {
      this.isAgencyModeAvailable = this.searchResponse?.items.some(
        (item) => item && item.agency && item.agency.currencySymbol && (item.agency.revenue > -1)
      );
    }
  }

  getFlow(): string {
    return this.appSettingsService.getFlow();
  }

  getProduct(): string {
    return this.appSettingsService.getProduct();
  }

  getLocale(): string {
    return this.appSettingsService.getLocale();
  }

  private shifuInitMetrics(response: SearchResponse, params: any): void {
    if (!this.appSettingsService.isWebview()) {

      Utils.init({
        product: this.appSettingsService.getProduct(),
        flow: this.appSettingsService.getFlow(),
        pageviewId: this.appSettingsService.getPageViewId(),
        ...(params?.params?.fromDate && { dates: [params?.params?.fromDate] }),
        /*origin*/
        ...(response?.travel?.points && response.travel.points[0]?.destination?.city && { origin: response.travel.points[0]?.destination?.city?.gid }),
        /*destination*/
        ...(response?.travel?.points && response.travel.points[1]?.destination?.city && { destination: response.travel.points[1]?.destination?.city?.gid })

      })

    }
  }

  comparePrices(response: SearchResponse) {
    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe(
      (params) => {
        const refererEvent = params.get(URLParamsConstants.REFERER_EVENT);
        const isFav =
          refererEvent && refererEvent.match(URLParamsConstants.FAV);

        if (!isFav) return;

        const clickedPrice = params.get(URLParamsConstants.CLICKED_PRICE);
        const serviceId = params.get(URLParamsConstants.SERVICE_ID);

        const [currency, price] = clickedPrice.split("_");
        const favoritePrice = parseInt(price);

        const foundItem = response?.items?.find(
          (item) => item.serviceId === serviceId
        );

        if (!foundItem) {
          this.message.type = MessageType.Info;
          this.message.title = this.translateService.instant('transfer-cluster.favorite.not.available.title');
          this.message.text = this.translateService.instant('transfer-cluster.favorite.not.available.text');
          return;
        }

        this.isFavoriteHighlighted = true;

        if (foundItem.prices[currency]) {
          const totalPrice = foundItem.prices[currency].totalPrice;

          if (favoritePrice === totalPrice) {
            this.message.type = MessageType.Success;
            this.message.title = this.translateService.instant('transfer-cluster.favorite.price.equal.title');
            this.message.text = this.translateService.instant('transfer-cluster.favorite.price.equal.text');
          } else if (favoritePrice > totalPrice) {
            let priceDown = favoritePrice - totalPrice;
            this.message.type = MessageType.SuccessOutline;
            this.message.title = this.translateService.instant('transfer-cluster.favorite.price.down.title');
            this.message.text = this.translateService.instant(
              'transfer-cluster.favorite.price.down.text',
              { '0': priceDown }
            );
          } else {
            this.message.type = MessageType.Info;
            this.message.title = this.translateService.instant('transfer-cluster.favorite.price.up.title');
            this.message.text = this.translateService.instant('transfer-cluster.favorite.price.up.text');
          }
        }
      });
  }

  selectedCurrencyDefined():boolean {
      return StaticValuesUtils.isPartnerAvailableCurrenciesEnabled() || this.showCurrencySelector;
  }

  private openBimonetaryNotificationModal() {

    if (!this.dcmService.showCurrencyModal()) return;

    const dynamicSize = typeof window !== 'undefined' && this.windowService.isMobile ? '-sm' : '-md';

    const data: ModalData = {
      id: 'dual-currency-modal',
      size: dynamicSize,
      product: this.appSettingsService.getProduct(),
      flow: this.appSettingsService.getFlow(),
      isWebview: this.appSettingsService.isWebview(),
      contentComponent: DualCurrencyModalWrapperComponent,
      contentModel: {
        currentCurrency: CurrencyConstants.CURRENCY_CODE_USD,
        alternativeCurrency: CurrencyConstants.CURRENCY_CODE_ARS,
        size: dynamicSize,
        texts: {
          title: this.translateService.instant('dual-currency-modal-wrapper.title'),
          description: this.translateService.instant('dual-currency-modal-wrapper.description'),
          switchLabel: this.translateService.instant('dual-currency-modal-wrapper.switchLabel'),
          keepLabel: this.translateService.instant('dual-currency-modal-wrapper.keepLabel')
        },
        onSwitchCurrency: (currency) => {
            this.currencyService.changeSelectedCurrencyAndSaveSelection(currency);
            this.reloadData();
        },
        onKeepCurrency: (currency) => {}
      }
    };

    this.modalService.showModal(data);
  }

}
